<template>
  <div class="sm:col-span-6">
    <label :for="id" class="block text-sm font-medium text-gray-700 pb-1">{{
      labelText
    }}</label>
    <div class="mt-1 sm:col-span-2 sm:mt-0">
      <select
        :id="id"
        :name="id"
        :required="required"
        class="input-primary mb-2 w-full"
        :class="[
          !errorMessage
            ? 'shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm'
            : 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 ',
        ]"
        @input="validate"
      >
        <option
          v-for="choice in choices"
          :key="choice.value"
          :value="choice.value"
        >
          {{ choice.label }}
        </option>
      </select>
      <div
        v-if="errorMessage"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-500"
          aria-hidden="true"
        />
      </div>
    </div>
    <p v-if="errorMessage && error" class="mt-2 text-sm text-action-red">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  name: "ChoiceElement",
  components: {
    ExclamationCircleIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
    choices: {
      type: Array,
      default: () => [],
    },
    validation: {
      type: Function,
      default: () => true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorKey: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "update-field"],
  data() {
    return {
      error: true,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
  },
  methods: {
    validate(event) {
      this.error = false;
      this.$emit("update-field", event.target.value);
    },
  },
};
</script>
